export const MAGIK_CONFIG = {
  projectId: "your-project-id",
  apiKey: "your-api-key",
  sdkTag: "universal@0.1.0",
  baseUrl: "https://magikauth.in/api"
};